import { Nullish } from '~/@types/generic'

import { GID } from '@unlikelystudio/commerce-connector'

export function getShopifyProductIdFromStoryblokData(data): Nullish<GID> {
  return data?.content?.['shopify_product']?.data?.id ?? null
}
